/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lastUpdate: NonNullable<unknown> }} Realtime_Unavailable_DescriptionInputs */



/**
* | output |
* | --- |
* | "The last data is from {lastUpdate}. Live display is momentarily unavailable." |
*
* @param {Realtime_Unavailable_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const realtime_unavailable_description = /** @type {((inputs: Realtime_Unavailable_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Realtime_Unavailable_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`The last data is from ${i?.lastUpdate}.
Live display is momentarily unavailable.`)
	return /** @type {LocalizedString} */ (`La dernière donnée remonte à ${i?.lastUpdate}.
L'affichage en direct est momentanément indisponible.`)
});